(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.lalyaCardCyclesReady) return;
    window.lalyaCardCyclesReady = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initCardCycles = (root = document) => {
      root.querySelectorAll('[data-lalya-card-cycle]').forEach((cycle) => {
        if (cycle.dataset.lalyaCycleReady === 'true') return;

        const slides = Array.from(cycle.querySelectorAll('.lalya-card-gallery__slide:not([hidden])'));
        if (slides.length < 2) return;

        cycle.dataset.lalyaCycleReady = 'true';

        let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (activeIndex < 0) {
          activeIndex = 0;
          slides[activeIndex].classList.add('is-active');
        }

        if (reducedMotion) return;

        window.setInterval(() => {
          if (document.hidden) return;
          slides[activeIndex].classList.remove('is-active');
          activeIndex = (activeIndex + 1) % slides.length;
          slides[activeIndex].classList.add('is-active');
        }, 2000);
      });
    };

    initCardCycles();
    document.addEventListener('shopify:section:load', (event) => initCardCycles(event.target));

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) initCardCycles(node);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
